<template>
  <div class="service-phone-list-editor">
    <el-table :data="items" border size="small" empty-text="暂无客服，请点击下方按钮添加">
      <el-table-column label="客服名称" min-width="180">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.name"
            placeholder="如：客服电话1、码头客服"
            @input="syncValue"
          />
        </template>
      </el-table-column>
      <el-table-column label="联系电话" min-width="180">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.phone"
            placeholder="请输入电话号码"
            @input="syncValue"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="text" :disabled="scope.$index === 0" @click="moveItem(scope.$index, 'up')">上移</el-button>
          <el-button
            type="text"
            :disabled="scope.$index === items.length - 1"
            @click="moveItem(scope.$index, 'down')"
          >下移</el-button>
          <el-button type="text" class="danger-text" @click="removeItem(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="editor-actions">
      <el-button type="primary" plain size="small" icon="el-icon-plus" @click="addItem">添加客服</el-button>
    </div>

    <div class="form-tips">
      <i class="el-icon-warning-outline"/> 小程序「客服中心」与「联系客服」弹窗将按列表顺序展示；保存后仍兼容原有 JSON 格式。
    </div>
  </div>
</template>

<script>
export default {
  name: "i-service-phone-list",
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      items: [],
      syncing: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (this.syncing) {
          return
        }
        this.items = this.parseValue(val)
      }
    }
  },
  methods: {
    parseValue(val) {
      if (!val || !String(val).trim()) {
        return []
      }
      try {
        const obj = JSON.parse(val)
        if (typeof obj !== "object" || obj === null || Array.isArray(obj)) {
          return []
        }
        return Object.keys(obj).map(name => ({
          name: name,
          phone: obj[name] == null ? "" : String(obj[name])
        }))
      } catch (e) {
        return []
      }
    },
    buildJson() {
      const obj = {}
      this.items.forEach(item => {
        const name = (item.name || "").trim()
        if (name) {
          obj[name] = (item.phone || "").trim()
        }
      })
      return JSON.stringify(obj)
    },
    syncValue() {
      this.syncing = true
      this.$emit("input", this.buildJson())
      this.$nextTick(() => {
        this.syncing = false
      })
    },
    addItem() {
      this.items.push({name: "", phone: ""})
      this.syncValue()
    },
    removeItem(index) {
      this.items.splice(index, 1)
      this.syncValue()
    },
    moveItem(index, direction) {
      if (direction === "up" && index > 0) {
        const temp = this.items[index]
        this.$set(this.items, index, this.items[index - 1])
        this.$set(this.items, index - 1, temp)
      }
      if (direction === "down" && index < this.items.length - 1) {
        const temp = this.items[index]
        this.$set(this.items, index, this.items[index + 1])
        this.$set(this.items, index + 1, temp)
      }
      this.syncValue()
    },
    validate() {
      const names = []
      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i]
        const name = (item.name || "").trim()
        const phone = (item.phone || "").trim()
        if (!name && !phone) {
          continue
        }
        if (!name) {
          return "请填写第 " + (i + 1) + " 条客服的名称"
        }
        if (!phone) {
          return "请填写「" + name + "」的联系电话"
        }
        if (names.indexOf(name) !== -1) {
          return "客服名称「" + name + "」重复，请修改"
        }
        names.push(name)
      }
      return ""
    }
  }
}
</script>

<style scoped lang="less">
.service-phone-list-editor {
  width: 100%;
}

.editor-actions {
  margin-top: 12px;
}

.danger-text {
  color: #F56C6C;
}
</style>



// WEBPACK FOOTER //
// src/components/i-service-phone-list.vue